import { render } from "./MainCurrencys.vue?vue&type=template&id=2f625944&scoped=true"
import script from "./MainCurrencys.vue?vue&type=script&lang=js"
export * from "./MainCurrencys.vue?vue&type=script&lang=js"

import "./MainCurrencys.vue?vue&type=style&index=0&id=2f625944&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f625944"]])

export default __exports__